export const END_POINT = 'http://138.197.195.9:4002/';

export const ATTACHMENT_END_POINT = 'http://138.197.195.9:4002/attachments/';

export const MESSAGE = 
    {
        "Error" : "Please enter mandatory fields",
        "library_create" : "Library created successfully",
        "library_upadte" : "Library updated successfully",
        "booking_success" : "Booking request send",
        "booking_time_slot": "Time slot added successfully",
        "booking_time_slot_update" : "Time slot updated successfully",
        "classMessage" : "Class created successfully ",
        "classUpdateMessage" : "Class updated successfully ",
        "user_upadte" : "User updated successfully",
        "team_edit_success" : "Team updated successfully",
        "team_member_added" : "Team member added successfully",
        "team_member_edited" : "Team member updated successfully",
        "password_changed" : "Password Changed successfully"
    }
